import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Layout
import { FloatingContact } from "./components/layout/FloatingContact";

// Auth bootstrap
import { authStore } from "./store/authStore";

// Pages
import HomePage          from "./pages/HomePage";
import CategoryPage      from "./pages/CategoryPage";
import SellPage          from "./pages/SellPage";
import ContactPage       from "./pages/ContactPage";
import BrandPage         from "./pages/BrandPage";
import QuestionnairePage from "./pages/QuestionnairePage";
import PricePage         from "./pages/PricePage";
import SchedulePage      from "./pages/SchedulePage";
import ConfirmationPage  from "./pages/ConfirmationPage";
import HowItWorksPage    from "./pages/HowItWorksPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage         from "./pages/TermsPage";
import LoginPage         from "./pages/LoginPage";
import MyOrdersPage      from "./pages/MyOrdersPage";

function AuthBootstrap({ children }: { children: React.ReactNode }) {
  useEffect(() => { authStore.ensureLoaded(); }, []);
  return <>{children}</>;
}

function AppRoutes() {
  const { pathname } = useLocation();
  return (
    <>
      <Routes>
        <Route path="/"               element={<HomePage />} />
        <Route path="/category/:categoryId" element={<CategoryPage />} />
        <Route path="/sell" element={<SellPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/brand/:brandId"  element={<BrandPage />} />
        <Route path="/questionnaire"   element={<QuestionnairePage />} />
        <Route path="/price"           element={<PricePage />} />
        <Route path="/schedule"        element={<SchedulePage />} />
        <Route path="/confirmation"    element={<ConfirmationPage />} />
        <Route path="/how-it-works"    element={<HowItWorksPage />} />
        <Route path="/privacy-policy"  element={<PrivacyPolicyPage />} />
        <Route path="/terms"           element={<TermsPage />} />
        <Route path="/login"           element={<LoginPage />} />
        <Route path="/my-orders"       element={<MyOrdersPage />} />
        <Route path="*"                element={<HomePage />} />
      </Routes>

      {/* Floating WhatsApp + Instagram — visible on every page */}
      <FloatingContact raised={pathname === "/"} />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthBootstrap>
        <AppRoutes />
      </AuthBootstrap>
    </BrowserRouter>
  );
}
